function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "New-Icon/Payer_Nr",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Safespace",
  x: 0,
  y: 0,
  width: 20,
  height: 20
}), /*#__PURE__*/React.createElement("g", {
  id: "numer_platnika",
  transform: "translate(0.000000, 2.000000)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Ikonka_Numer_p\\u0142atnika"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#48A9A1",
  opacity: 0.2,
  x: 2.24,
  y: 0.88,
  width: 17.48,
  height: 11.76,
  rx: 0.38
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#48A9A1",
  x: 0.87,
  y: 5,
  width: 16.73,
  height: 3
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#48A9A1",
  x: 12.86,
  y: 10.52,
  width: 2.62,
  height: 1.74,
  rx: 0.58
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.59,14.51 L0.87,14.51 C0.593857625,14.51 0.37,14.2861424 0.37,14.01 L0.37,3 C0.37,2.72385763 0.593857625,2.5 0.87,2.5 L17.59,2.5 C17.8661424,2.5 18.0901001,2.72385763 18.0901001,3 L18.0901001,14 C18.0926872,14.1343323 18.0411975,14.2640935 17.9471364,14.3600357 C17.8530754,14.455978 17.7243592,14.51 17.59,14.51 L17.59,14.51 Z M1.37,13.51 L17.09,13.51 L17.09,3.5 L1.37,3.5 L1.37,13.51 Z",
  id: "Shape",
  fill: "#555150"
}))));

var SvgCreditCard = function SvgCreditCard(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCreditCard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/CreditCard.a12d37f0.svg";
export { ForwardRef as ReactComponent };